import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import BaseComponent from './BaseComponent';
import { pagerActionTypes, compStatusTypes } from '../../Constants';
import { ManualData } from '../../static';
import Style from './Manual.cssmodule.less';
import { updateItemIndex, clickButton } from '../../actions/Modal';
import Progress from '../CommonSet/Progress';
import Pager from '../CommonSet/Pager';
import Button from '../CommonSet/Button';
import Media from '../CommonSet/Media';
import Title from '../CommonSet/Title';

class Manual extends BaseComponent {
    constructor(props) {
        super(props);
        this.manualData = ManualData[props.item.content];
        this.maxIndex = this.manualData.length;

        this.handleButtonClick = this.handleButtonClick.bind(this);
        this.handlePagerClick = this.handlePagerClick.bind(this);

        this.state = this.getPagerStatus(props);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.itemIndex !== this.props.itemIndex) {
            this.setState(this.getPagerStatus(nextProps));
        }
    }

    handlePagerClick(status) {
        const { updateItemIndex } = this.props.actions;
        let itemIndex = this.props.itemIndex;
        if (status === pagerActionTypes.NEXT) {
            itemIndex += 1;
        } else if (status === pagerActionTypes.PREV) {
            itemIndex -= 1;
        }
        updateItemIndex(itemIndex);
    }

    handleButtonClick(event) {
        const { clickButton } = this.props.actions;
        clickButton({
            event,
        });
    }

    getPagerStatus(props) {
        const pagerStatus = {};
        if (props.itemIndex <= 0) {
            pagerStatus.prevStatus = compStatusTypes.HIDDEN;
            if (props.itemIndex !== this.maxIndex - 1) {
                pagerStatus.nextStatus = compStatusTypes.ENABLED;
            } else {
                pagerStatus.nextStatus = compStatusTypes.HIDDEN;
            }
        } else if (props.itemIndex >= this.maxIndex - 1) {
            pagerStatus.prevStatus = compStatusTypes.ENABLED;
            pagerStatus.nextStatus = compStatusTypes.HIDDEN;
        } else {
            pagerStatus.prevStatus = compStatusTypes.ENABLED;
            pagerStatus.nextStatus = compStatusTypes.ENABLED;
        }

        return pagerStatus;
    }

    createContent() {
        let view = null;
        const { itemIndex } = this.props;
        const { content } = this.manualData[itemIndex];
        if (content) {
            view = (
                <div
                    className={Style.content}
                    dangerouslySetInnerHTML={{
                        __html: content,
                    }}
                />
            );
        }

        return view;
    }

    createMediaView() {
        let view = null;
        const { itemIndex } = this.props;
        const { media } = this.manualData[itemIndex];

        if (media) {
            view = <Media className={Style.media} media={media} />;
        }

        return view;
    }

    createButtonView() {
        const { itemIndex } = this.props;
        if (itemIndex !== this.maxIndex - 1) {
            return null;
        }

        return (
            <div className={Style.buttonView}>
                <Button
                    className={Style.button}
                    onClick={(e) => this.handleButtonClick('start')}
                    text={this.Utils.getLang('Buttons.get_started')}
                />
            </div>
        );
    }

    render() {
        return (
            <div className={Style.manual}>
                <Title
                    className={Style.title}
                    onClose={(e) => this.handleButtonClick('close')}
                >
                    {this.manualData[this.props.itemIndex].title}
                </Title>
                <Progress
                    nowValue={this.props.itemIndex}
                    maxValue={this.maxIndex}
                    progressStatus={compStatusTypes.ENABLED}
                    indicatorStatus={compStatusTypes.ENABLED}
                />
                <div
                    className={
                        // IE Flex 버그 이슈로 생성
                        // http://codepen.io/chriswrightdesign/pen/emQNGZ/
                        Style.flexWrapperView
                    }
                >
                    <div className={Style.wrapperView}>
                        <Pager
                            onPagerClick={this.handlePagerClick}
                            prevStatus={this.state.prevStatus}
                            nextStatus={this.state.nextStatus}
                        >
                            <div className={Style.contentView}>
                                {this.createContent()}
                                {this.createMediaView()}
                            </div>
                        </Pager>
                        {this.createButtonView()}
                    </div>
                </div>
            </div>
        );
    }
}

Manual.displayName = 'Manual';
Manual.propTypes = {};

function mapDispatchToProps(dispatch) {
    const actions = { clickButton, updateItemIndex };
    const actionMap = { actions: bindActionCreators(actions, dispatch) };
    return actionMap;
}

export default connect(
    undefined,
    mapDispatchToProps
)(Manual);



// WEBPACK FOOTER //
// ./components/ModalSet/Manual.js